import { useFormContext } from 'react-hook-form';
import { FormControlLabel, TextField } from '@mui/material';

const OperatingUnitField = () => {
  const { register } = useFormContext();

  return <FormControlLabel label="OU OWNER" required control={<TextField disabled {...register('source_ou')} />} />;
};

export default OperatingUnitField;
